<template>
	<div class="section s6">
		<div class="title">我们的赞助商</div>
		<div class="line"></div>
		<div class="list">
			<div class="center">
				<div class="left item" @click="util.toLink('https://www.microsoft.com/zh-cn/','','_blank')"><div class="img"></div></div>
				<div class="left item" @click="util.toLink('https://www.intel.cn/content/www/cn/zh/homepage.html','','_blank')"><div class="img"></div></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'sponsor',
	data() {
		return {}
	},
	components:{

	},
	computed:{

	},
	methods: {

	},
	mounted() {

	},
}
</script>

<style lang="scss" type="text/scss" scoped>
.s6{text-align: center;background: #fff;padding:.5rem 0;
	.title{font-size: .34rem;text-align: center;line-height:.4rem;;padding:0 .25rem 0;}
	.line{width: 1.8rem;height:.06rem;background: url("../../assets/image/80.png") no-repeat center center;background-size: contain;  margin: .1rem auto 0;}
	.list{display: inline-block;margin-top:.5rem;
		.center{display: inline-block;
			.item{width:3rem;height:1rem;box-shadow: 0 0 10px 5px rgba(0,0,0,.1);border-radius:.05rem;margin-right: .3rem;background: #fff;
				.img{width: 2rem;height:.6rem;margin: .2rem auto 0;}
			}
			.item:nth-last-child(1){margin-right: 0;}
			.item:nth-child(1) .img{background:url("../../assets/image/s1.png") no-repeat center center;background-size: contain;}
			.item:nth-child(2) .img{background:url("../../assets/image/s2.png") no-repeat center center;background-size: contain;background-size: 70%}
		}
	}
}
</style>